import { useState } from "react";
import { useDispatch} from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordMutation, useLoginMutation } from "../slices/usersApiSlice";
import { setCredentials } from "../slices/authSlice";
import "./css/Login.css";
import {Link} from "react-router-dom";
import { Button, Col, Flex, Input, Row, Space, Typography, notification } from "antd";
import Logo from "../images/Lincfolio.png";
import Laptop from "../images/laptop.png";
import { MailOutlined, SendOutlined } from "@ant-design/icons";
import { motion } from "framer-motion"

const ForgotpasswordScreen = () => {
  const [api, contextHolder] = notification.useNotification();

const { Title, Text } = Typography;
const navigate = useNavigate();

const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

const [email, setEmail] = useState("");

const handleForgotpassword = async (e) => {
  e.preventDefault();
    try {
      const res = await forgotPassword({ email}).unwrap();

      api.success({
        message: "Password reset link sent to you email! Kindly check your email.",
      });
    } catch (err) {
    
      api.error({
        message: err?.data?.message || err.error || err?.data?.error,
      });
      
    }
}
return (
<>
  {contextHolder}
  <form onSubmit={(e) => handleForgotpassword(e)}>
  <Flex align="center" className="login-background" style={{height: "100vh"}} >
    <Row justify="space-around" style={{width: "100%"}}>
      <Col xs={{span: 22, order: 2}} lg={{span: 6, order: 1, offset: 2}} className="background-blur"  style={{ padding: "20px", height: "350px",boxShadow: '0px 3px 6px 0px rgba(0, 0, 0, 0.12)'}}>
        <h1>Forgot Password</h1>
        
          <Space direction='vertical' style={{width: "100%"}}>
          <p>Enter your email id to get password reset link to your email.</p>
            <Input placeholder="Email" addonBefore={<MailOutlined/>} onChange={(e) => setEmail(e.target.value)} required/>
            <Button type="primary" htmlType="submit">Send Email <SendOutlined/></Button>
            <Flex justify="start">
              <p>Go Back to  <Link to={"/register"}> Login Page!</Link></p>
            </Flex>
          </Space>
      </Col>
      <Col xs={{span: 22, order: 1}} lg={{span: 16, order: 2}} style={{ padding: "20px", textAlign: "center" }}>
        {/* <motion.div   initial={{y: 100, opacity: 0}} animate={{ y: 0, opacity: 1 }} transition={{ ease: "easeOut", duration: 2 }}>
          <img src={Logo} alt="Lincfolio" className="logo" /><br/>
        </motion.div>
        <motion.div   initial={{y: 100, opacity: 0}} animate={{ y: 0, opacity: 1 }} transition={{ ease: "easeOut", duration: 2, delay: 0.5 }}>
          <img src={Laptop} alt="Lincfolio-Laptop" className="laptop" /><br/>
        </motion.div>
        <motion.div   initial={{y: 100, opacity: 0}} animate={{ y: 0, opacity: 1 }} transition={{ ease: "easeOut", duration: 2, delay: 1 }}>
          <p style={{fontSize: "18pt"}}>"Lincfolio, your trading tool, making profits easy and cool!"</p><br/>
        </motion.div> */}
      </Col>
    </Row>
  </Flex>
  </form>
</>
)
};
export default ForgotpasswordScreen;

